"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    id: "*upload"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M1.99967 9.33301C2.36786 9.33301 2.66634 9.63148 2.66634 9.99967V12.6663C2.66634 12.8432 2.73658 13.0127 2.8616 13.1377C2.98663 13.2628 3.1562 13.333 3.33301 13.333H12.6663C12.8432 13.333 13.0127 13.2628 13.1377 13.1377C13.2628 13.0127 13.333 12.8432 13.333 12.6663V9.99967C13.333 9.63148 13.6315 9.33301 13.9997 9.33301C14.3679 9.33301 14.6663 9.63148 14.6663 9.99967V12.6663C14.6663 13.1968 14.4556 13.7055 14.0806 14.0806C13.7055 14.4556 13.1968 14.6663 12.6663 14.6663H3.33301C2.80257 14.6663 2.29387 14.4556 1.91879 14.0806C1.54372 13.7055 1.33301 13.1968 1.33301 12.6663V9.99967C1.33301 9.63148 1.63148 9.33301 1.99967 9.33301Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_2",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.19526 6.19526C4.45561 5.93491 4.87772 5.93491 5.13807 6.19526L8 9.05719L10.8619 6.19526C11.1223 5.93491 11.5444 5.93491 11.8047 6.19526C12.0651 6.45561 12.0651 6.87772 11.8047 7.13807L8.4714 10.4714C8.21106 10.7318 7.78894 10.7318 7.5286 10.4714L4.19526 7.13807C3.93491 6.87772 3.93491 6.45561 4.19526 6.19526Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_3",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.99967 1.33301C8.36786 1.33301 8.66634 1.63148 8.66634 1.99967V9.99967C8.66634 10.3679 8.36786 10.6663 7.99967 10.6663C7.63148 10.6663 7.33301 10.3679 7.33301 9.99967V1.99967C7.33301 1.63148 7.63148 1.33301 7.99967 1.33301Z",
    fill: fill
  })));
};

exports["default"] = _default;